export default __webpack_public_path__ + "static/media/bandage.682821c4.png";